<template>
  <div class="bg_login">
    <div class="login_container">
      <div class="login_bg">
        <div class="login_icon_box">
          <!-- 步骤 15：品牌英文副标 + 中文品牌名 + 渐变分隔线 + 大字号单位名（品牌名固定，单位名选中后联动切换） -->
          <div class="login_icon_sub">MEDICAL EDUCATION PLATFORM</div>
          <!-- 中文品牌名：固定展示平台名称，不随单位切换 -->
          <div class="login_icon_sub_cn">医学教育智能化服务平台</div>
          <div class="login_icon_line"></div>
          <!-- 中间大字号展示登录单位名称（仅展示，选择动作在下方单位下拉完成，选完联动显示） -->
          <div class="login_icon_name" :title="displayLogoName">{{ displayLogoName }}</div>
        </div>
      </div>
      <div class="login_box">
        <div class="avatar_box">
          欢迎登录
        </div>
        <!-- 账号密码登录表单区域 -->
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form"
          v-if="loginWay == 1">
          <div class="login_header_title">
            <div class="on" @click="loginWay = 1">
              <div>账号密码登录</div>
              <div class="login_header_title_box">
                <span></span>
              </div>
            </div>
            <div class="login_header_kong"></div>
            <div @click="loginWay = 0" v-if="isphoneLogin == 0">
              <div>手机免密登录</div>

            </div>
          </div>
          <div class="login_header_box">
            <el-form-item style="margin: 0;">
              <el-select v-model="loginForm.id" filterable clearable style="width:100%" placeholder="输入你所在的单位"
                popper-class="login-unit-popper" @change="changeselect">
                <el-option v-for="item in UnitOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="login_header_box_title">账号</div>
          <!-- 账号 -->
          <div class="login_header_box">
            <el-form-item prop="account" style="margin: 0;">
              <el-input v-model="loginForm.account" placeholder="请输入账号" @keyup.enter.native="login"></el-input>
            </el-form-item>
          </div>

          <!-- 密码 -->
          <div class="login_header_box_title">密码</div>
          <div style="margin-bottom: 19px;">
            <el-form-item prop="password" style="margin: 0;">
              <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" @keyup.enter.native="login">
              </el-input>
            </el-form-item>
          </div>
          <!-- 验证码 -->
          <div class="login_header_box_title">验证码</div>
          <div class="captcha">

            <el-form-item prop="captchaCode" style="margin: 0;">
              <el-input v-model="loginForm.captchaCode" placeholder="请输入验证码" @keyup.enter.native="login">
              </el-input>
            </el-form-item>

            <el-image style="height: 40px;" :src="captchaUrl" fit="contain" @click="getCaptcha" />
          </div>
          <div class="zhuce">
            <template v-if="isphoneLogin == 0"><router-link
                to="/ForgetPassword"><span>忘记密码?</span></router-link></template>

            <!-- <router-link to="/register"><span style="color: #409EFF;">注册账号</span></router-link> -->
          </div>
          <!-- 按钮区域 -->
          <div class="btns" @click="login">登录</div>
        </el-form>
        <!-- 手机免密登录 -->
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form"
          v-if="loginWay == 0 && isphoneLogin == 0">
          <div class="login_header_title">
            <div>
              <div @click="loginWay = 1">账号密码登录</div>
            </div>
            <div class="login_header_kong"></div>
            <div class="on" @click="loginWay = 0">
              <div>手机免密登录</div>
              <div class="login_header_title_box">
                <span></span>
              </div>
            </div>
          </div>

          <div class="login_header_box_title">手机号</div>
          <!-- 手机号 -->
          <div class="login_header_box">
            <el-form-item prop="phone">
              <el-input v-model="phoneloginForm.phone" placeholder="请输入手机号" @keyup.enter.native="phonelogin"></el-input>
            </el-form-item>
          </div>

          <!-- 验证码 -->
          <div class="login_header_box_title">验证码</div>
          <div>
            <el-form-item prop="password" style="margin: 0;">
              <div style="display: flex;">
                <div class="code">
                  <el-input v-model="phoneloginForm.checkCode" placeholder="请输入验证码" @keyup.enter.native="phonelogin">
                  </el-input>
                </div>
                <!-- <span class="yz" v-show="show" slot="suffix" @click="getCode">获取验证码</span><span class="yz"
                  v-show="!show" slot="suffix">{{count}}s</span> -->
                <div class="yz">
                  <div class="yz_btn" v-if="show" @click="getCode">获取验证码</div>
                  <div class="yz_btn1" style="background-color: var(--color-primary);" v-else disabled>重新获取({{ count }})s</div>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="zhuce">
            <router-link to="/ForgetPassword"><span>忘记密码?</span></router-link>
            <!-- <router-link to="/register"><span style="color: #409EFF;">注册账号</span></router-link> -->
          </div>
          <!-- 按钮区域 -->
          <div class="btns" @click="phonelogin">
            登录
          </div>
        </el-form>
        <div v-if="isphoneLogin == 0" class="more">更多登录方式</div>
        <div v-if="isphoneLogin == 0" class="weixin" @click="wxLogin()"><img src="../assets/weixin.png" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loginWay: 1,
      captchaUrl: '',
      show: true,
      count: '',
      timer: null,
      code: '',
      state: '',
      // 这是账号密码登录表单的数据绑定对象
      loginForm: {
        id: '',
        cpyId: '',
        account: '',
        password: '',
        captchaKey: '',
        captchaCode: '',
      },
      // 单位
      UnitOptions: [],
      // 这是登录的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        account: [{
          required: true,
          message: '请输入登录名称',
          trigger: 'blur'
        },
        {
          min: 0,
          max: 20,
          message: '长度在 0 到 20 个字符',
          trigger: 'blur'
        }
        ],
        // 验证密码是否合法
        password: [{
          required: true,
          message: '请输入登录密码',
          trigger: 'blur'
        },
          // {// 银行卡号
          //   validator: validatePassword,
          //   trigger: 'blur'
          // },
          // {
          //   min: 6,
          //   max: 20,
          //   message: '密码为6到20位英文字母和数字组合',
          //   trigger: 'change'
          // }
        ],
        // 验证是否选择单位
        cpyId: [{
          required: true,
          message: '请选择单位',
          trigger: 'blur'
        }]
      },
      // 手机免密登录
      phoneloginForm: {
        phone: '',
        checkCode: ''
      },
      // 这是手机登录的验证规则对象
      phoneloginFormRules: {
        checkCode: [{// 验证验证码是否合法
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        },
        {
          min: 6,
          max: 6,
          message: '验证码错误',
          trigger: 'blur'
        }
        ],
        phone: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        },
        {
          min: 11,
          max: 11,
          message: '手机号码错误',
          trigger: 'blur'
        }
        ]
      },
      isphoneLogin: '',
      logoName: '医学教育智能化服务平台',
      logoUrl: null,

      //type=1:测试环境单位,type=2 正式环境单位,type=3武大SP,type=4天门市第一人民医院
      //登录页根据type显示对应的单位,不需要显示写''，需要显示写对应的数字
      // type: 3,
      type: '',
      sType: '',// 缓存的type
      isChangePassword: false,//是否需要修改为强密码
    }
  },
  computed: {
    // 中间品牌区大字号名称：实时随下拉选中单位联动。
    // 不依赖 @change 事件（事件链路可能受全局插件/环境干扰），只要 v-model="loginForm.id"
    // 更新，computed 即自动重算，从根上保证"选择单位 → 中间名称切换"必定生效。
    displayLogoName() {
      const id = this.loginForm.id
      if (id === '' || id === null || id === undefined) {
        // 未选中单位：若已有默认单位名（本地化部署单单位场景由 getUnitList 写入 logoName），
        // 则显示它，否则显示平台名
        return this.logoName || '医学教育智能化服务平台'
      }
      const found = this.UnitOptions.find(o => String(o.id) === String(id))
      if (found) {
        // 单位名 name 优先：接口的 logoName 是所有单位共用的平台品牌名，
        // 用户要求中间显示"登录单位的名称"
        return found.name || found.logoName || '医学教育智能化服务平台'
      }
      // 兜底：走 changeselect / getUnitList 设置过的 logoName
      return this.logoName || '医学教育智能化服务平台'
    }
  },
  created() {
    // 这里设置接口域名
    //天门本地化部署
    if (window.localStorage.getItem('userStorage')) {
      this.loginForm = JSON.parse(window.localStorage.getItem('userStorage'))
    } else if (window.localStorage.getItem('loginUnitId')) {
      // 未登录但缓存过上次选择的单位：恢复默认选中，中间单位名随之显示
      this.loginForm.id = window.localStorage.getItem('loginUnitId')
      // 立即用缓存名称恢复中间展示（不依赖异步接口；getUnitList 返回后再用最新数据校准）
      const cachedName = window.localStorage.getItem('loginUnitName')
      if (cachedName) this.logoName = cachedName
    }


    axios.defaults.baseURL = process.env.VUE_APP_LOGIN_BASE// 'https://service.zhihuiyijiao.com' //智教会

    // axios.defaults.baseURL = 'https://api-tianmen-px.zhihuiyijiao.com'// 天门打包地方

    // axios.defaults.baseURL = 'https://api-bjxkyy.zhihuiyijiao.com'// 首都医科大学附属北京胸科医院打包地方

    axios.defaults.wsuri = 'wss://service.zhihuiyijiao.com/ws'
    // axios.defaults.wsuri = 'ws://192.168.112.32:8083/mqtt'// 江西信丰

    window.sessionStorage.setItem('baseURL', axios.defaults.baseURL)
    window.sessionStorage.setItem('wsuri', axios.defaults.wsuri)
    // 截取地址栏id,addr参数
    this.code = this.$utils.getUrlKey('code');
    this.state = this.$utils.getUrlKey('state');
    if (this.code) {
      this.wxgoin()
    }
    this.getUnitList()
    this.getCaptcha()
  },
  methods: {
    getCaptcha() {
      this.$http.get('auth/captcha').then(res => {
        if (res.data) {
          const { data } = res.data
          this.captchaUrl = data.captchaBase64
          this.loginForm.captchaKey = data.captchaKey
        }
      })
    },

    changeselect(e) {
      // 清空单位选择时恢复默认平台名称
      if (e === '' || e === null || e === undefined) {
        this.logoName = '医学教育智能化服务平台'
        this.logoUrl = null
        this.loginForm.cpyId = ''
        window.localStorage.removeItem('loginUnitId')
        window.localStorage.removeItem('loginUnitName')
        return
      }
      for (let key in this.UnitOptions) {
        // 宽松比较：接口 id 与下拉选中值可能 number/string 不一致，=== 会匹配失败导致名称不联动
        if (String(this.UnitOptions[key].id) === String(e)) {
          this.loginForm.cpyId = this.UnitOptions[key].cpyId
          this.isphoneLogin = this.UnitOptions[key].phoneLogin
          // 单位名 name 优先（接口 logoName 是平台品牌名，所有单位相同），再兜底平台名
          this.logoName = this.UnitOptions[key].name || this.UnitOptions[key].logoName || '医学教育智能化服务平台'
          this.logoUrl = this.UnitOptions[key].logoUrl
          this.sType = this.UnitOptions[key].type
          axios.defaults.baseURL = this.UnitOptions[key].serviceUrl
          axios.defaults.wsuri = this.UnitOptions[key].wssUrl
          axios.defaults.cosMinioSwitch = this.UnitOptions[key].cosMinioSwitch
          window.sessionStorage.setItem('baseURL', axios.defaults.baseURL)
          window.sessionStorage.setItem('wsuri', axios.defaults.wsuri)
          window.sessionStorage.setItem('cosMinioSwitch', axios.defaults.cosMinioSwitch)

          // 记住本次选择的单位：下次打开登录页默认选中并显示单位名
          window.localStorage.setItem('loginUnitId', String(e))
          window.localStorage.setItem('loginUnitName', this.logoName || '')

          return
        }
      }
    },
    async wxgoin() {
      let state = window.sessionStorage.getItem('state')
      if (this.state != state) {
        return
      }
      const {
        data: res
      } = await this.$Http.loginweChatWeb({
        code: this.code
      })

      if (res.result !== 0) return this.$message.error(res.msg)
      this.$message.success('登录成功')
      window.sessionStorage.setItem('token', res.data.token)
      window.sessionStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
      window.localStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
      // window.localStorage.setItem('userStorage', JSON.stringify(this.loginForm))
      // 2. 通过编程式导航跳转到后台主页，路由地址是 /home
      this.gohome()
    },
    wxLogin() {
      // https://zjh.zhihuiyijiao.com/#/login?code=081XrD000QE2rM10A4000EYVjv4XrD0s&state=52751416
      var url = 'https://zjh.zhihuiyijiao.com/#/login';
      var code = '';
      var codeLength = 8;
      //设置随机字符
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
      //循环codeLength 我设置的4就是循环4次
      for (var i = 0; i < codeLength; i++) {
        //设置随机数范围,这设置为0 ~ 36
        var index = Math.floor(Math.random() * 9);
        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
      }
      //将拼接好的字符串赋值给展示的code
      const suffixUrl = url.split("?")[1];
      if (suffixUrl == null || suffixUrl == "" || suffixUrl == undefined) {
        var appID = "wx0a1b704a2bbd079a";
        var redirectUri = url;
        // 授权接口地址
        window.sessionStorage.setItem('state', code)
        var strUrl = "https://open.weixin.qq.com/connect/qrconnect?appid=" + appID + "&redirect_uri=" +
          encodeURIComponent(redirectUri) +
          "&response_type=code&scope=snsapi_login&state=" + code;
        window.location.href = strUrl;
      }
    },
    async getUnitList() {
      let params
      if (this.type == '') {
        params = {
          terminal: 1,
          // business: '1,2,3,4,5',// 区分业务
        }
      } else {
        params = {
          terminal: 1,
          business: '1,2,3,4,5',
          type: this.type,
          // outInNetwork: 'in'
        }
      }
      if (process.env.VUE_APP_LOGIN_TYPE) {
        params.type = process.env.VUE_APP_LOGIN_TYPE
      }
      // params.type = 4 // 天门打包地方，放开注释
      // params.type = 5//首都医科大学附属北京胸科医院打包地方，放开注释
      const {
        data: res
      } = await this.$http.get('company/login/list', {
        params: params
      })

      if (res.result !== 0) {
        return this.$message.error('获取单位列表失败！')
      }
      // let userItem = window.localStorage.getItem('userStorage')
      // userItem = JSON.parse(userItem)
      if (this.type != '') {
        this.logoName = res.data.list[0].name || res.data.list[0].logoName || '医学教育智能化服务平台'
        this.logoUrl = res.data.list[0].logoUrl
        this.sType = res.data.list[0].type
        // if(res.data.list[0].logoUrl!=null){
        //   this.logoUrl=res.data.list[0].logoUrl
        // }
        // this.type=res.data.list[0].type
      }
      this.UnitOptions = res.data.list
      if (res.data.list.length == 1) {
        this.loginForm.id = this.UnitOptions[0].id
        this.loginForm.cpyId = this.UnitOptions[0].cpyId
        this.isphoneLogin = this.UnitOptions[0].phoneLogin
        this.logoName = this.UnitOptions[0].name || this.UnitOptions[0].logoName || '医学教育智能化服务平台'
        this.logoUrl = this.UnitOptions[0].logoUrl
        this.sType = this.UnitOptions[0].type
        axios.defaults.baseURL = this.UnitOptions[0].serviceUrl
        axios.defaults.wsuri = this.UnitOptions[0].wssUrl
        window.sessionStorage.setItem('baseURL', axios.defaults.baseURL)
        window.sessionStorage.setItem('wsuri', axios.defaults.wsuri)
        return
      }
      if (window.localStorage.getItem('userStorage') || window.localStorage.getItem('loginUnitId')) {
        // 有登录缓存或单位缓存时，恢复上次选中单位及其中间展示名称
        for (let key in res.data.list) {
          if (String(res.data.list[key].id) === String(this.loginForm.id)) {
            this.loginForm.cpyId = this.UnitOptions[key].cpyId
            this.isphoneLogin = this.UnitOptions[key].phoneLogin
            this.logoName = this.UnitOptions[key].name || this.UnitOptions[key].logoName || '医学教育智能化服务平台'
            this.logoUrl = this.UnitOptions[key].logoUrl
            this.sType = this.UnitOptions[key].type
            // 关键：el-option 的 value 是接口原始类型（number），el-select 用 === 回显选中项，
            // 缓存里的是字符串，必须改回原始类型，下拉框才能默认选中上次单位
            this.loginForm.id = res.data.list[key].id
            axios.defaults.baseURL = this.UnitOptions[key].serviceUrl
            axios.defaults.wsuri = this.UnitOptions[key].wssUrl
            window.sessionStorage.setItem('baseURL', axios.defaults.baseURL)
            window.sessionStorage.setItem('wsuri', axios.defaults.wsuri)
            break
          }
        }
        return
      }

      //

      // this.loginForm.cpyId = this.UnitOptions[0].cpyId
      // this.isphoneLogin = this.UnitOptions[0].phoneLogin
      // axios.defaults.baseURL = this.UnitOptions[0].serviceUrl
      // axios.defaults.wsuri = this.UnitOptions[0].wssUrl
      // window.sessionStorage.setItem('baseURL', axios.defaults.baseURL)
      // window.sessionStorage.setItem('wsuri', axios.defaults.wsuri)
    },
    // 账号密码登录
    login() {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return
        const {
          data: res
        } = await this.$Http.loginAccount(this.loginForm)
        if (res.result !== 0) {
          this.getCaptcha()
          return this.$message.error(res.msg)
        }
        // this.$message.success('登录成功')
        this.$message({
          message: '登录成功!',
          type: 'success',
          duration: 500
        });

        // 1. 将登录成功之后的 token，保存到客户端的 sessionStorage 中
        //   1.1 项目中出了登录之外的其他API接口，必须在登录之后才能访问
        //   1.2 token 只应在当前网站打开期间生效，所以将 token 保存在 sessionStorage 中
        window.sessionStorage.setItem('token', res.data.token)
        window.sessionStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
        window.localStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
        window.localStorage.setItem('userStorage', JSON.stringify(this.loginForm))
        window.localStorage.setItem('sType', this.sType)
        window.localStorage.setItem('typeId', this.type)
        window.localStorage.setItem('logoUrl', this.logoUrl)

        // 2. 登录成功后进行页面跳转
        let userAccount = JSON.parse(window.sessionStorage.getItem('userAccount'))
        if (userAccount.cpyId == 110 && res.data.needChangePassword === true) {// 110天门 需要进行强密码修改登录后跳转到修改密码界面
          this.$router.push('/user?to=' + '111')
        } else if ((userAccount.cpyId == 201 || userAccount.cpyId == 213) && userAccount.roleId == 8) {
          this.$router.push('/vpthome')
        } else {
          this.$router.push('/home') //通过编程式导航跳转到后台主页，路由地址是 /home
        }

      })
    },
    // 手机免密登录
    async phonelogin() {

      if (this.phoneloginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (this.phoneloginForm.checkCode == '') {
        return this.$message.error('请输入验证码')
      }
      // this.$refs.phoneloginFormRef.validate(async valid => {
      //   if (!valid) return
      // const {
      //   data: res
      // } = await this.$http.get('auth/login/phone', {
      //   params: this.phoneloginForm
      // })
      const {
        data: res
      } = await this.$Http.loginPhone(this.phoneloginForm)

      if (res.result !== 0) return this.$message.error(res.msg)
      this.$message.success('登录成功')
      // 1. 将登录成功之后的 token，保存到客户端的 sessionStorage 中
      //   1.1 项目中出了登录之外的其他API接口，必须在登录之后才能访问
      //   1.2 token 只应在当前网站打开期间生效，所以将 token 保存在 sessionStorage 中
      window.sessionStorage.setItem('token', res.data.token)
      window.sessionStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
      window.localStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
      // 2. 通过编程式导航跳转到后台主页，路由地址是 /home
      this.gohome()
      // 1. 将登录成功之后的 token，保存到客户端的 sessionStorage 中
      //   1.1 项目中出了登录之外的其他API接口，必须在登录之后才能访问
      //   1.2 token 只应在当前网站打开期间生效，所以将 token 保存在 sessionStorage 中
      // window.sessionStorage.setItem('token', res.data.token)
      // // 2. 通过编程式导航跳转到后台主页，路由地址是 /home
      // })
    },

    // 验证码
    async getCode() {
      const TIME_COUNT = 60;


      const {
        data: res
      } = await this.$http.get('phone/send/checkcode', {
        params: {
          phone: this.phoneloginForm.phone,
          deviceToken: this.$md5("czkj-2021" + this.phoneloginForm.phone + "2021-czkj"),
          type: 2
        }
      })

      if (res.result == 0) {
        this.$message.success('发送成功！')
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.captcha {
  display: flex;
  justify-content: space-between;
  gap: 6px;

  /* 步骤 13：验证码图片与输入框风格统一（边框/圆角） */
  /deep/ .el-image {
    width: 120px;
    height: 40px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    flex-shrink: 0;
  }
}

.bg_login {
  // 步骤 13：纯 CSS 渐变背景（性能友好，无背景图/无动画库/无新依赖）
  // 步骤 14：色值变量化，与侧边栏(--sidebar-bg)/主色(--color-primary)/信息蓝(--color-info-blue)同族协调
  background: linear-gradient(135deg, var(--color-login-bg-deep) 0%, var(--color-primary) 55%, var(--color-info-blue) 100%);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;

  /* 装饰光斑：纯 CSS radial-gradient，无 filter，不影响加载性能 */
  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
  }

  &::before {
    width: 560px;
    height: 560px;
    left: -180px;
    top: -200px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 70%);
  }

  &::after {
    width: 680px;
    height: 680px;
    right: -220px;
    bottom: -260px;
    background: radial-gradient(circle, rgba(87, 188, 245, 0.30) 0%, rgba(87, 188, 245, 0) 70%);
  }
}

.login_container {
  width: 1056px;
  max-width: 90%;
  min-width: 0;
  height: 575px;
  min-height: 575px;
  overflow: hidden;
  margin: auto;
  border-radius: 16px;
  background-color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  /* 步骤 13：深色投影，与渐变背景协调 */
  box-shadow: 0 20px 60px rgba(6, 26, 56, 0.35);
}

.code {
  width: 176px;
}

.login_bg {
  width: 588px;
  height: 100%;
  position: relative;
  /* 步骤 13：品牌区渐变（深海蓝 → 医疗蓝 → 浅青，与侧边栏/登录页背景同族）
     步骤 14：色值变量化，直接联动 --sidebar-bg / --color-primary / --color-info-blue */
  background: linear-gradient(160deg, var(--sidebar-bg) 0%, var(--color-primary) 62%, var(--color-info-blue) 100%);
  border-radius: 16px 0 0 16px;

    .login_icon_box {
      width: 100%;
      height: 100%; /* 占满左栏全高，flex 居中使品牌内容在左栏上下正中 */
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      /* 品牌英文副标：小号半透明白 + 宽字距，与中文单位名形成品牌/单位层级，避免重复 */
      .login_icon_sub {
        font-size: 15px;
        letter-spacing: 5px;
        color: rgba(255, 255, 255, 0.65);
        margin-bottom: 10px;
        white-space: nowrap;
        padding-left: 5px; /* 抵消 letter-spacing 的视觉偏移，保证真正居中 */
      }

      /* 中文品牌名：固定展示平台名称（不随单位切换），比英文副标大、比单位名小，形成三级层级 */
      .login_icon_sub_cn {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 4px;
        color: rgba(255, 255, 255, 0.92);
        margin-bottom: 16px;
        white-space: nowrap;
        padding-left: 4px; /* 抵消 letter-spacing 的视觉偏移，保证真正居中 */
      }

      /* 渐变分隔细线：两端透明中间亮白，精致不抢眼 */
      .login_icon_line {
        width: 48px;
        height: 2px;
        border-radius: 2px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0) 100%);
        margin-bottom: 22px;
      }

      .login_icon_name {
        width: 88%;
        font-size: 40px;
        font-weight: 700;
        color: #FFFFFF;
        text-align: center;
        line-height: 1.5;
        letter-spacing: 2px;
        text-shadow: 0 2px 8px rgba(6, 26, 56, 0.3);
        word-break: break-all;
      }
    }
  }

.login_box {
  width: 467px;
  height: 100%;
  background-color: #FFFFFF;
  border-radius: 16px;
  /* 卡片浮起质感，与左栏品牌区渐变呼应 */
  box-shadow: 0 24px 56px rgba(6, 26, 56, 0.18);

  .avatar_box {
    padding: 38px 75px 18px;
    width: 100%;
    font-size: 24px;
    color: var(--color-primary);
    font-weight: 700;
    letter-spacing: 1px;
  }

  .login_header_title {
    width: 100%;
    display: flex;
    cursor: pointer;
    margin-bottom: 14px; /* 与下方单位下拉间隔收窄 */

    div {
      font-size: 16px;
      height: 40px;
      display: flex;
      flex-direction: column;
      color: #909399;
      transition: color 0.2s;
    }

    div:hover {
      color: var(--color-primary);
    }

    .login_header_title_box {
      display: flex;
      align-items: center;

      span {
        width: 32px;
        height: 3px;
        background-color: var(--color-primary);
        border-radius: 3px;
      }
    }
  }

  .login_header_kong {
    width: 32px;
  }
}

.login_form {
  // position: absolute;
  // top: 20px;
  width: 100%;
  padding: 0 75px;
  box-sizing: border-box;

  /* 步骤 4：输入框浅色背景 + 淡边框 + 大圆角 + 聚焦主色描边（纯 CSS transition） */
  /deep/ .el-input__inner {
    height: 44px;
    line-height: 44px;
    border-radius: 10px;
    background-color: #F6F8FB;
    border-color: #E3E8F0;
    font-size: 16px;
    color: #303133;
    transition: border-color 0.2s, box-shadow 0.2s, background-color 0.2s;
  }

  /deep/ .el-input__inner::placeholder {
    color: #A8B0BF;
  }

  /deep/ .el-input__inner:hover {
    border-color: #C6D0DE;
  }

  /deep/ .el-input__inner:focus,
  /deep/ .el-select .el-input.is-focus .el-input__inner {
    background-color: #FFFFFF;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 2px var(--color-primary-glow);
  }
}

.btns {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  display: flex;
  background-color: var(--color-primary);
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 4px;
  color: #FFFFFF;
  cursor: pointer;
  box-shadow: 0 6px 16px var(--color-primary-shadow);
  transition: background-color 0.2s, box-shadow 0.2s, transform 0.15s;

  &:hover {
    background-color: var(--color-primary-hover);
    box-shadow: 0 8px 20px var(--color-primary-shadow-hover);
    transform: translateY(-1px);
  }
}

.code {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.zhuce {
  width: 100%;
  display: flex;
  height: 25px;
  justify-content: flex-end;
  margin-bottom: 18px;

  span {
    font-size: 14px;
    color: var(--color-primary);
    cursor: pointer;
    transition: opacity 0.2s;
  }

  span:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
}

.login_title {
  height: 75px;
  width: 1200px;
  max-width: 90%;
  margin: 27px auto 0;

  img {
    width: 100%;
  }
}

.on {
  color: var(--color-primary);
  font-weight: 600;
}

.yz {
  width: 124px;
}

.weixin {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 13px;

  img {
    width: 27px;
  }
}

.login_bg_title {
  width: 100%;
  height: 93px;
  line-height: 93px;
  text-align: center;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  letter-spacing: 4px;
  padding-left: 4px; /* 抵消 letter-spacing 造成的视觉偏移，保持真正居中 */
  /* 步骤 13：深色渐变背景上的文字投影，保证可读性 */
  text-shadow: 0 1px 4px rgba(6, 26, 56, 0.35);
}

.login_header_box {
  margin-bottom: 18px;
}

.login_header_box_title {
  margin-bottom: 8px;
  font-size: 15px;
  color: #4B5563;
  font-weight: 600;
}

.more {
  margin-top: 26px;
  font-size: 13px;
  color: #A8B0BF;
  width: 100%;
  text-align: center;
  letter-spacing: 2px;
  position: relative;

  /* 左右装饰细线，视觉上划分"微信登录"区块，更精致 */
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 62px;
    height: 1px;
    background-color: #E8ECF3;
  }

  &::before {
    left: 6px;
  }

  &::after {
    right: 6px;
  }
}

.yz_btn {
  width: 136px;
  height: 42px;
  border-radius: 10px;
  background-color: var(--color-primary);
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--color-primary-hover);
  }
}

.yz_btn1 {
  width: 136px;
  height: 42px;
  border-radius: 10px;
  background-color: var(--color-primary);
  opacity: 0.3;
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ===== 步骤 9：Pad / Mobile 登录页移动化 ===== */
/* Pad / Mobile：隐藏左侧品牌区，仅保留登录表单 */
html[data-bp='pad'] .login_bg,
html[data-bp='mobile'] .login_bg {
  display: none;
}

/* Pad：登录容器收窄居中 */
html[data-bp='pad'] .login_container {
  width: 467px;
  max-width: 92%;
  height: auto;
  min-height: 0;
}

/* Mobile：登录容器全屏化 */
html[data-bp='mobile'] .login_container {
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  border-radius: 0;
  box-shadow: none;
}

html[data-bp='mobile'] .login_box {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

html[data-bp='mobile'] .login_form {
  padding: 0 24px;
}

html[data-bp='mobile'] .login_box .avatar_box {
  padding: 24px 24px 14px;
}

/* Mobile：验证码/手机验证码区域收窄，避免溢出 */
html[data-bp='mobile'] .code {
  width: 120px;
}

html[data-bp='mobile'] .yz,
html[data-bp='mobile'] .yz_btn,
html[data-bp='mobile'] .yz_btn1 {
  width: 96px;
}
</style>

<!-- 步骤 5：登录页单位下拉框样式（popper 挂载在 body 下，须用非 scoped 样式） -->
<style lang="less">
.login-unit-popper.el-select-dropdown {
  border-radius: 8px;
  border-color: #E4E9F2;
  box-shadow: 0 8px 24px rgba(6, 26, 56, 0.12);

  .el-select-dropdown__item {
    font-size: 14px;
    height: 38px;
    line-height: 38px;
    color: #303133;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #F2F6FC;
  }

  .el-select-dropdown__item.selected {
    color: var(--color-primary);
    font-weight: 600;
  }
}
</style>
